<template>
  <div>
    <AdminPlusDrawer v-if="$store.state.adminPlusVersion" :drawer="drawer" :minimizedDrawer="minimizedDrawer"
      :permissionsLoaded="permissionsLoaded" :darkTheme="darkTheme" @update:drawer="$emit('update:drawer', $event)"
      @update:minimizedDrawer="$emit('update:minimizedDrawer', $event)" @show-welcome-dialog="handleShowWelcomeDialog"
      @show-migration-dialog="handleShowMigrationDialog" @start-onboarding="handleStartOnboarding" />
    <AppDrawer v-else :drawer="drawer" :minimizedDrawer="minimizedDrawer" :permissionsLoaded="permissionsLoaded"
      :darkTheme="darkTheme" @update:drawer="$emit('update:drawer', $event)"
      @update:minimizedDrawer="$emit('update:minimizedDrawer', $event)" @navigate="handleNavigate"
      @close-nav="handleCloseNav" @reload-and-refresh="handleReloadAndRefresh" @back-to-bjjlink="handleBackToBjjlink"
      @to-tablet="handleToTablet" @go-to-releases="handleGoToReleases" />
  </div>
</template>

<script>
import AppDrawer from "./Drawer.vue";
import AdminPlusDrawer from "./AdminPlusDrawer.vue";

export default {
  name: "NavigationDrawer",
  components: {
    AppDrawer,
    AdminPlusDrawer,
  },
  props: {
    drawer: {
      type: Boolean,
      default: true,
    },
    minimizedDrawer: {
      type: Boolean,
      default: true,
    },
    permissionsLoaded: {
      type: Boolean,
      default: false,
    },
    darkTheme: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    /** @param {any} route */
    handleNavigate(route) {
      this.$emit("navigate", route);
    },
    handleCloseNav() {
      this.$emit("close-nav");
    },
    handleReloadAndRefresh() {
      this.$emit("reload-and-refresh");
    },
    handleBackToBjjlink() {
      this.$emit("back-to-bjjlink");
    },
    handleToTablet() {
      this.$emit("to-tablet");
    },
    handleGoToReleases() {
      this.$emit("go-to-releases");
    },
    handleShowWelcomeDialog() {
      this.$emit("show-welcome-dialog");
    },
    handleShowMigrationDialog() {
      this.$emit("show-migration-dialog");
    },
    handleStartOnboarding() {
      this.$emit("start-onboarding");
    },
  },
};
</script>
